module.exports = __webpack_public_path__ + "static/img/s54.65e5dadd.png";